// loading-popup.js
(function () {
      // Create loading popup (second popup for processing)
      const loadingPopup = document.createElement('div');
      loadingPopup.id = 'pixar-loading-popup';
      loadingPopup.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.98);
        z-index: 99999999;
        display: none;
        overflow: auto;
        padding: 20px;
        box-sizing: border-box;
        font-family: Helvetica, Arial, sans-serif;
      `;
      
      // Add content to the loading popup - improved and cleaner
      loadingPopup.innerHTML = `
        <div style="position: relative; max-width: 700px; margin: 100px auto; padding: 40px; background: white; border-radius: 12px; box-shadow: 0 0 30px rgba(0,0,0,0.1); font-family: Helvetica, Arial, sans-serif;">
          <h3 style="text-align: center; font-size: 26px; margin-bottom: 30px; color: #333; font-weight: bold; font-family: Helvetica, Arial, sans-serif;">Generating...</h3>
          
          <div style="width: 90%; max-width: 500px; height: 12px; background-color: #f5f5f5; border-radius: 20px; margin: 30px auto; overflow: hidden; box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);">
            <div id="pixar-progress-bar" style="height: 100%; width: 10%; background: linear-gradient(to right, #1E316A, #2A4380); transition: width 1s ease-in-out; border-radius: 20px;"></div>
          </div>
          
          <p id="pixar-progress-text" style="text-align: center; margin: 20px 0; color: #555; font-size: 18px; font-weight: 500; font-family: Helvetica, Arial, sans-serif;">Preparing your image</p>
          
          <p style="text-align: center; margin-top: 15px; color: #777; font-size: 15px; font-family: Helvetica, Arial, sans-serif;">Usually takes 20-30 seconds.</p>
        </div>
      `;

  document.body.appendChild(loadingPopup);

  // Store all active intervals globally
  window.activeLoadingIntervals = window.activeLoadingIntervals || [];

  // Helper function to clear all loading intervals
  function clearAllLoadingIntervals() {
    // Clear any template-specific intervals
    if (window.singleFaceSwapProgressInterval) {
      clearInterval(window.singleFaceSwapProgressInterval);
      window.singleFaceSwapProgressInterval = null;
    }
    if (window.pixarProgressInterval) {
      clearInterval(window.pixarProgressInterval);
      window.pixarProgressInterval = null;
    }
    if (window.petTransformProgressInterval) {
      clearInterval(window.petTransformProgressInterval);
      window.petTransformProgressInterval = null;
    }
    if (window.petTransformCopyProgressInterval) {
      clearInterval(window.petTransformCopyProgressInterval);
      window.petTransformCopyProgressInterval = null;
    }
    if (window.roomFlagPollingInterval) {
      clearInterval(window.roomFlagPollingInterval);
      window.roomFlagPollingInterval = null;
    }
    if (window.threeMenProgressInterval) {
      clearInterval(window.threeMenProgressInterval);
      window.threeMenProgressInterval = null;
    }
    // Clear any stored intervals
    window.activeLoadingIntervals.forEach(interval => clearInterval(interval));
    window.activeLoadingIntervals = [];
    // Reset progress tracking
    window.currentLoadingProgress = null;
  }

  // Global functions
  window.showLoadingPopup = function () {
    // Clear any existing intervals first
    clearAllLoadingIntervals();
    
    // Reset progress
    window.setLoadingProgress(5, 'Preparing your image...');
    loadingPopup.style.display = 'block';
    document.body.style.overflow = 'hidden';
  };

  window.hideLoadingPopup = function (text="Finished!!") {
    // Clear all intervals when hiding
    clearAllLoadingIntervals();
    
    // Get fresh DOM references
    const progressBar = loadingPopup.querySelector('#pixar-progress-bar');
    const progressText = loadingPopup.querySelector('#pixar-progress-text');
    
    if (progressBar && progressText) {
      progressBar.style.width = "100%";
      progressText.textContent = text;
    }

    setTimeout(() =>{
        loadingPopup.style.display = 'none';
        document.body.style.overflow = '';
    }, 1500);
  };

  window.setLoadingProgress = function (percent, text='Preparing your image...') {
    if (percent < 0) percent = 0;
    if (percent > 100) percent = 100;
    
    // Get fresh DOM references each time
    const progressBar = loadingPopup.querySelector('#pixar-progress-bar');
    const progressText = loadingPopup.querySelector('#pixar-progress-text');
    
    if (progressBar) {
      progressBar.style.width = percent + '%';
    }
    if (progressText) {
      progressText.textContent = text;
    }
  };
})();
